import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import QcRangeDetails from './qcRangeDetails';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteQcRange } from '../../../../services/clinicPortalServices/qcRangeService';
import { Checkbox } from '@mui/material';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

import RecordDetails from '../../../common/RecordDetails';
const panelStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.3)', zIndex: 1040
    },
    panel: {
        position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh',
        background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
        zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto'
    },
    header: {
        padding: '16px 20px', borderBottom: '1px solid #e0e0e0',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: '#f8f9fa'
    },
    title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
    body: { padding: '20px', flex: 1 },
    section: { marginBottom: '20px' },
    sectionTitle: {
        fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em',
        textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px',
        borderBottom: '1px solid #eee'
    },
    dl: { display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: '8px', margin: 0 },
    dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
    dd: { fontSize: '13px', color: '#222', margin: 0 },
    editBtn: {
        background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px',
        padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px'
    },
    closeBtn: {
        background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666'
    }
};

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            qcRangeId: props.data._id
        };
    }

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this analyte!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteQcRange({
                    _id: this.state.qcRangeId,
                    name: this.props.data.name
                }).then(() => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
        const qcRange = this.props.data;
        if (qcRange) {
            const label = qcRange.analyteId?.name ? `${qcRange.analyteId.name} - ${qcRange.controlType}` : 'QC Range';
            trackRecentView('qc_range', qcRange._id, label, '/clinic/qcRanges');
        }
    };

    handleClose = () => this.setState({ show: false });

    handleBulkChecked = () => {
        this.props.context.componentParent.handleBulkChecked(this.props.data._id);
    };

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>QC Range Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                <i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit
                            </button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Range Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Analyte</dt>
                                <dd style={panelStyles.dd}>{d.analyteId?.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Control Type</dt>
                                <dd style={panelStyles.dd}>{d.controlType || '—'}</dd>
                                <dt style={panelStyles.dt}>Result Type</dt>
                                <dd style={panelStyles.dd}>{d.resultType || '—'}</dd>
                                <dt style={panelStyles.dt}>Target Value</dt>
                                <dd style={panelStyles.dd}>{d.targetValue != null ? d.targetValue : '—'}</dd>
                                <dt style={panelStyles.dt}>SD</dt>
                                <dd style={panelStyles.dd}>{d.sdValue != null ? d.sdValue : '—'}</dd>
                                <dt style={panelStyles.dt}>Min Valid Range</dt>
                                <dd style={panelStyles.dd}>{d.minValidRange != null ? d.minValidRange : '—'}</dd>
                                <dt style={panelStyles.dt}>Max Valid Range</dt>
                                <dd style={panelStyles.dd}>{d.maxValidRange != null ? d.maxValidRange : '—'}</dd>
                            </dl>
                        </div>
                        {d.resultChoices && (
                            <div style={panelStyles.section}>
                                <div style={panelStyles.sectionTitle}>Result Choices</div>
                                <div style={{ fontSize: '13px', color: '#222' }}>{d.resultChoices}</div>
                            </div>
                        )}
                        {d.validValues && (
                            <div style={panelStyles.section}>
                                <div style={panelStyles.sectionTitle}>Valid Values</div>
                                <div style={{ fontSize: '13px', color: '#222' }}>{d.validValues}</div>
                            </div>
                        )}
                    
                        <RecordDetails data={d} exclude={['analyteId', 'controlType', 'maxValidRange', 'minValidRange', 'resultChoices', 'resultType', 'sdValue', 'targetValue', 'validValues', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View QC Range</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Edit QC Range</Tooltip>}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Delete QC Range</Tooltip>}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
                {this.props.context.componentParent?.state?.isBulkSelect && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Select to Create QC Sample</Tooltip>}>
                        <Checkbox
                            checked={this.props.context.componentParent.state.bulkCheckedIds.includes(this.props.data._id)}
                            onClick={() => this.handleBulkChecked()}
                        />
                    </OverlayTrigger>
                )}
                {this.state.showPanel && this.renderPanel()}
                <ModalStyled size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.show} onHide={this.handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Update QC Range Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcRangeDetails qcRangeId={this.state.qcRangeId} context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
